var _ellipse, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect5, _rect6, _rect7, _path25, _rect8, _rect9, _rect0, _rect1, _rect10, _path26, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlicks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 793.57972,
    height: 828,
    viewBox: "0 0 793.57972 828",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Memory storage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.98059,
    cy: 776,
    rx: 294,
    ry: 52,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.17389,322.2052c0-75.75611,111.08263-137.16857,248.11-137.16857s248.11,61.41246,248.11,137.16857",
    transform: "translate(-203.21014 -36)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M685.2975,237.85074H483.44675Q423.562,136.92537,483.44675,36H685.2975Q601.56463,136.92537,685.2975,237.85074Z",
    transform: "translate(-203.21014 -36)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 309.07244,
    y: 24.02985,
    width: 113.74129,
    height: 14.41791,
    fill: "#536dfe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 272.22667,
    y: 71.28856,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 272.22667,
    y: 96.1194,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272.22667,
    y: 120.95025,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M765.88672,684.65948c0,64.01613,40.16036,115.81717,89.79084,115.81717",
    transform: "translate(-203.21014 -36)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M855.67756,800.47665c0-64.73541,44.81663-117.11848,100.20137-117.11848",
    transform: "translate(-203.21014 -36)",
    fill: "#536dfe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M798.41964,690.46265c0,60.80852,25.6095,110.014,57.25792,110.014",
    transform: "translate(-203.21014 -36)",
    fill: "#536dfe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M855.67756,800.47665c0-82.71747,51.801-149.65139,115.81717-149.65139",
    transform: "translate(-203.21014 -36)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M836.78788,801.29318s12.73382-.39219,16.57147-3.12493,19.58782-5.99579,20.53985-1.61307,19.13657,21.79764,4.76015,21.9136-33.4044-2.23935-37.23467-4.57251S836.78788,801.29318,836.78788,801.29318Z",
    transform: "translate(-203.21014 -36)",
    fill: "#a8a8a8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M878.91591,816.94314c-14.37642.116-33.40439-2.23933-37.23466-4.57251-2.917-1.77683-4.07933-8.15253-4.46826-11.094-.26934.01158-.4251.01657-.4251.01657s.80653,10.26991,4.6368,12.60309,22.85824,4.6885,37.23466,4.5725c4.14991-.03347,5.58335-1.50994,5.50465-3.69673C883.58748,816.09323,882.00474,816.91824,878.91591,816.94314Z",
    transform: "translate(-203.21014 -36)",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M561.03984,193.68167c1.169.536,2.57518-.263,3.26431-1.34876,2.62406-4.13443-2.20717-9.46554-1.16106-14.24935.8381-3.83254,5.19311-6.10727,6.08355-9.928.8652-3.71246-1.8008-7.897.00115-11.25619,1.41173-2.63171,4.93809-3.32425,7.88874-2.86321s5.75131,1.75814,8.73222,1.93988c3.97213.24218,7.75852-1.5064,11.64257-2.37277s8.62166-.52716,10.90658,2.731c2.93387,4.18352-.04223,10.00893.97933,15.01551.81119,3.97556,4.13936,7.26743,4.21087,11.32428.02541,1.44192-3.76518.28033-3.5637,1.70833s-1.59011.17065-.158.001a2.83656,2.83656,0,0,0,2.15525-2.56349c.17028-1.18939,2.40545-1.58586,2.37966-2.78711-.06043-2.81524,5.02939-.91705,5.86761-3.60529a27.26083,27.26083,0,0,0-1.11407-19.01732c-1.1415-2.561-2.69605-4.98476-3.24677-7.73406-.74772-3.73277.42879-7.73995-.80445-11.34159-1.662-4.85372-7.16143-7.328-12.26714-7.83054s-10.29417.397-15.37075-.344c-4.54775-.66384-8.95048-2.63481-13.53754-2.34924-5.50405.34266-10.29366,3.889-14.109,7.87087s-7.05186,8.56161-11.385,11.97279a22.32925,22.32925,0,0,0-3.65052,3.14268c-2.207,2.6895-2.43084,6.52085-1.81689,9.94536s1.94987,6.69111,2.51394,10.12419c.53009,3.2263.36656,6.52246.59488,9.784s.90531,6.622,2.86966,9.23562a8.71633,8.71633,0,0,0,6.78255,3.54347c.91842.02117,1.69412-.80408,2.62108-.58889C559.50761,192.10982,560.01142,193.21015,561.03984,193.68167Z",
    transform: "translate(-203.21014 -36)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "318.546 394.707 321.95 415.619 328.759 406.378 324.868 392.275 318.546 394.707",
    fill: "#a0616a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M526.13312,272.65061,520.77258,286.777s-5.33864,71.95337-5.33864,77.303,3.89061,73.92158,5.34959,76.83954c0,0,6.32224-9.2402,14.58979-7.78122s4.86326-24.31631,4.86326-24.31631l7.78122-63.70874-1.459-32.09753Z",
    transform: "translate(-203.21014 -36)",
    fill: "#575a89"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M526.13312,272.65061,520.77258,286.777s-5.33864,71.95337-5.33864,77.303,3.89061,73.92158,5.34959,76.83954c0,0,6.32224-9.2402,14.58979-7.78122s4.86326-24.31631,4.86326-24.31631l7.78122-63.70874-1.459-32.09753Z",
    transform: "translate(-203.21014 -36)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2033,194.83842s16.04877,40.8514,6.80857,48.63262,51.55058-13.13081,51.55058-13.13081l-1.459-5.34959s-19.93937-7.78122-10.21285-30.15222S559.2033,194.83842,559.2033,194.83842Z",
    transform: "translate(-203.21014 -36)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2033,194.83842s16.04877,40.8514,6.80857,48.63262,51.55058-13.13081,51.55058-13.13081l-1.459-5.34959s-19.93937-7.78122-10.21285-30.15222S559.2033,194.83842,559.2033,194.83842Z",
    transform: "translate(-203.21014 -36)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M533.91434,740.49646s-6.80857-1.94531-10.69918,2.918-18.48039,17.02142-18.48039,17.02142-28.20693-2.918-32.09754,11.1855,44.25569,14.10347,55.92752,10.69918,14.10346,0,14.10346,0,35.98814,2.918,35.98814-2.918-3.40428-25.77529-3.40428-25.77529Z",
    transform: "translate(-203.21014 -36)",
    fill: "#575a89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M648.201,773.08031l-6.32225,19.453S622.912,818.795,633.61122,824.14457s48.63262,10.69918,48.63262-3.40429V793.99234s-3.89061-18.96672-7.78122-20.912S648.201,773.08031,648.201,773.08031Z",
    transform: "translate(-203.21014 -36)",
    fill: "#575a89"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M540.80155,423.59059s-20.50434,17.81523-20.018,20.24686S530.99638,602.3798,530.99638,602.3798L536.346,703.53566s-6.80857,23.83-3.40428,29.17958-4.86327,6.80856-4.86327,6.80856,35.01549,31.61121,49.60528,17.99407l13.61714-176.53642L628.748,709.37158s6.32224,68.08567,13.61713,68.08567,36.9608,1.459,36.47447-2.43163,1.459-33.55651-1.94531-51.06426-26.26161-156.11072-26.26161-156.11072-1.96507-118.82188,3.15124-129.92824-2.66492-22.7782-2.66492-22.7782l-34.04283-13.13081-40.85141,4.86327Z",
    transform: "translate(-203.21014 -36)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 378.8505,
    cy: 141.33067,
    r: 34.04284,
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M664.7361,250.76593a30.53711,30.53711,0,0,0-21.39836-19.453,188.628,188.628,0,0,1-28.69324-9.72652s-34.52917,16.53509-41.33773,16.53509-6.80857-4.37694-6.80857-4.37694-17.50775,18.4804-26.74795,20.42571-22.85733,24.80263-17.99407,37.44712A70.56789,70.56789,0,0,0,535.85964,313.502s-1.9453,68.08567,4.37694,80.73015c0,0-15.56244,29.6659-.97265,31.61121s70.5173-4.86326,80.24383,1.9453,27.72059-1.459,30.15222,7.78122,7.78122,11.18551,7.78122,11.18551,8.26755-13.13081,3.40429-20.912S664.7361,250.76593,664.7361,250.76593Z",
    transform: "translate(-203.21014 -36)",
    fill: "#575a89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M628.748,433.6246l-7.78122,4.86326s8.26754,28.69325,11.67183,29.6659S644.056,443.61932,644.056,443.61932Z",
    transform: "translate(-203.21014 -36)",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M555.20393,190.27739c1.169.536,2.57517-.263,3.2643-1.34877,2.62407-4.13442-2.20717-9.46554-1.161-14.24935.83809-3.83254,5.19311-6.10726,6.08354-9.928.86521-3.71245-1.80079-7.897.00116-11.25618,1.41173-2.63171,4.93809-3.32426,7.88874-2.86322s5.7513,1.75814,8.73222,1.93989c3.97212.24217,7.75851-1.50641,11.64256-2.37277s8.62167-.52717,10.90659,2.731c2.93387,4.18351-.04224,10.00892.97932,15.0155.81119,3.97557,10.0535,6.766,10.89171,4.07773a27.26075,27.26075,0,0,0-1.11407-19.01731c-1.14149-2.561-2.696-4.98476-3.24676-7.73406-.74772-3.73277.42878-7.73995-.80445-11.34159-1.662-4.85372-7.16144-7.328-12.26714-7.83054s-10.29418.397-15.37075-.344c-4.54775-.66385-8.95048-2.63481-13.53755-2.34924-5.50405.34266-10.29365,3.889-14.109,7.87086s-7.05186,8.56162-11.385,11.97279a22.32931,22.32931,0,0,0-3.65052,3.14269c-2.207,2.6895-2.43085,6.52085-1.81689,9.94536s1.94987,6.69111,2.51393,10.12419c.5301,3.22629.36656,6.52245.59488,9.784s.90532,6.622,2.86967,9.23561a8.71634,8.71634,0,0,0,6.78255,3.54348c.91841.02117,1.69411-.80409,2.62107-.58889C553.6717,188.70554,554.17551,189.80587,555.20393,190.27739Z",
    transform: "translate(-203.21014 -36)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M645.52621,259.27664l15.8056-8.51071s38.41978,91.42934,29.17958,116.7183-44.742,77.32587-44.742,77.32587-28.20692-5.83591-25.289-11.67183,21.88468-43.283,23.34366-48.1463,11.1855-36.47446,6.80857-39.87875S637.745,262.68093,637.745,262.68093Z",
    transform: "translate(-203.21014 -36)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M645.28305,245.41634l19.453,5.34959s38.41977,91.42934,29.17957,116.7183-44.742,77.32587-44.742,77.32587-28.20692-5.83591-25.289-11.67183,21.88468-43.283,23.34366-48.1463,11.18551-36.47446,6.80857-39.87875-25.289-87.53872-25.289-87.53872Z",
    transform: "translate(-203.21014 -36)",
    fill: "#575a89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M855.39385,322.2052c0,79.425-111.08262,143.81163-248.11,143.81163s-248.11-64.38666-248.11-143.81163",
    transform: "translate(-203.21014 -36)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M810.26354,468.05793c-55.45907,29.91083-127.8227,48.011-206.98144,48.011-75.89677,0-145.54691-16.63914-200.04-44.37389",
    transform: "translate(-203.21014 -36)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M731.188,147.90572c105.54421,27.741,180.712,88.76157,187.70175,160.63026",
    transform: "translate(-203.21014 -36)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.37337,261.82294c17.78361-32.68552,50.27112-61.45009,92.83643-83.54855",
    transform: "translate(-203.21014 -36)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M520.56793,611.70682H722.41867q59.88471-100.92537,0-201.85074H520.56793Q604.3008,510.78145,520.56793,611.70682Z",
    transform: "translate(-203.21014 -36)",
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 384.14592,
    y: 412.30384,
    width: 113.74129,
    height: 14.41791,
    fill: "#536dfe"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 375.33497,
    y: 455.55757,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 375.33497,
    y: 480.38841,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M435.00323,474.6996H233.15249q-59.88471-100.92537,0-201.85074H435.00323Q351.27038,373.77423,435.00323,474.6996Z",
    transform: "translate(-203.21014 -36)",
    fill: "#f2f2f2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.37022,
    y: 260.87871,
    width: 113.74129,
    height: 14.41791,
    fill: "#536dfe"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27.53937,
    y: 300.92846,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 27.53937,
    y: 325.75931,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 27.53937,
    y: 350.59015,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.53937,
    y: 375.421,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M764.99677,381.72016H966.84751q59.88471-100.92537,0-201.85074H764.99677Q848.72962,280.79479,764.99677,381.72016Z",
    transform: "translate(-203.21014 -36)",
    fill: "#f2f2f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 626.17177,
    y: 163.8943,
    width: 113.74129,
    height: 14.41791,
    fill: "#536dfe"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 614.15684,
    y: 203.94405,
    width: 150.58706,
    height: 4.80597,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlicks);
export default __webpack_public_path__ + "static/media/plicks.db6c3375b2192218dc9dbee6955f7d6c.svg";
export { ForwardRef as ReactComponent };